import { useEffect } from "react";
import { toast } from "sonner";
import { Share2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_TITLE = "kiwibares.nz — Naturism in Aotearoa New Zealand";

export function usePageMeta(title, description) {
  useEffect(() => {
    if (!title) return;
    document.title = `${title} — kiwibares.nz`;
    const meta = document.querySelector('meta[name="description"]');
    const prev = meta?.getAttribute("content");
    if (meta) meta.setAttribute("content", description || prev);
    return () => {
      document.title = DEFAULT_TITLE;
      if (meta && prev) meta.setAttribute("content", prev);
    };
  }, [title, description]);
}

export default function ShareButton({ kind, slug, title }) {
  const url = `${BACKEND_URL}/api/share/${kind}/${slug}`;
  const share = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
        return;
      } catch {
        // fall through to copy
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied — it shows a preview image when shared");
    } catch {
      window.prompt("Copy this link", url);
    }
  };
  return (
    <button onClick={share} data-testid="share-button" data-share-url={url}
      className="inline-flex items-center gap-2 border border-[#e2dcd4] bg-white px-4 py-2 text-sm text-[#1f402b] hover:border-[#1f402b] transition-colors">
      <Share2 size={14} /> Share
    </button>
  );
}
